import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestImportPost = {
    path: "/import",
    method: RouteHttpVerb.POST
};
